import React, { ReactNode } from 'react';
import { Helmet } from 'react-helmet-async';

import { PageHeader, PageHeaderProps } from '@occc-app/design-system';
import { Container, ContainerProps } from '../Container';

type PageProps = {
  children?: React.ReactNode;
  browserTabTitle: string;
  actions?: React.ReactNode | ReactNode[];
  pageHeaderProps: PageHeaderProps;
  containerProps?: ContainerProps;
};

export const Page = ({
  browserTabTitle,
  pageHeaderProps,
  actions,
  children,
  containerProps,
}: PageProps) => {
  return (
    <>
      <Helmet>
        <title>{browserTabTitle}</title>
      </Helmet>
      <Container {...containerProps} includesPageHeader>
        <PageHeader {...pageHeaderProps}>{actions}</PageHeader>
        {children}
      </Container>
    </>
  );
};
